(() => {
  if (customElements.get('kd-home-hero-v2')) return;
  const requests = new Map();

  customElements.define('kd-home-hero-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const reviews = this.querySelector('[data-tp-apikey]');
      if (!reviews?.dataset.tpApikey || !reviews.dataset.tpBusinessunit) return;
      const url = `https://api.trustpilot.com/v1/business-units/${encodeURIComponent(reviews.dataset.tpBusinessunit)}?apikey=${encodeURIComponent(reviews.dataset.tpApikey)}`;
      if (!requests.has(url)) {
        requests.set(url, fetch(url).then(response => response.ok ? response.json() : null).catch(() => null));
      }
      requests.get(url).then(data => {
        if (!this.isConnected) return;
        const count = data?.numberOfReviews?.total;
        if (Number.isInteger(count) && count >= 0) {
          this.querySelector('[data-hero-count]').textContent = count.toLocaleString('en-GB');
        }
        const rating = data?.score?.trustScore;
        if (typeof rating === 'number' && Number.isFinite(rating) && rating >= 0 && rating <= 5) {
          this.querySelector('[data-hero-rating]').textContent = rating.toFixed(1);
          this.querySelector('.kd-home-hero-v2__stars').style.setProperty('--star-fill', `${rating * 20}%`);
        }
      });
    }
  });
})();
